/**
 * @generated SignedSource<<afb0085c396278c78d18461885afe9f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type switchSalesChannelDialogPriceQuery$variables = {
  salesChannelID: string;
};
export type switchSalesChannelDialogPriceQuery$data = {
  readonly salesChannelSwitchPrice: {
    readonly productCount: number;
    readonly totalPrice: number;
  } | null;
};
export type switchSalesChannelDialogPriceQuery = {
  response: switchSalesChannelDialogPriceQuery$data;
  variables: switchSalesChannelDialogPriceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      }
    ],
    "concreteType": "ProductSwitcherPriceOutput",
    "kind": "LinkedField",
    "name": "salesChannelSwitchPrice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalPrice",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "switchSalesChannelDialogPriceQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "switchSalesChannelDialogPriceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "58a57870cb4d18c49e245d924960d397",
    "id": null,
    "metadata": {},
    "name": "switchSalesChannelDialogPriceQuery",
    "operationKind": "query",
    "text": "query switchSalesChannelDialogPriceQuery(\n  $salesChannelID: ID!\n) {\n  salesChannelSwitchPrice(salesChannelID: $salesChannelID) {\n    productCount\n    totalPrice\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c7165c6cdf0666dbf3dde177d31e76d";

export default node;
